import {Box,MenuItem,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {ACTIVE_STATUS,handleValidateCodevalue,PRODUCT_TYPE,} from "../Utility/constant";
import { useDispatch, useSelector } from "react-redux";
import { requestHideLoader, requestShowLoader } from "../Store/Global/action";
import TextFiledWithLabel from "./TextFieldWithLabel";
import LeadDialog from "./LeadDialog";
import { emptyAllProducts, requestGetAllActiveProducts } from "../Store/Product/action";
import SelectBoxWithLabel from "./SelectBoxWithLable";
export const ChooseProductType = ({
    value,
    searchState,
    handleChangeSearchField,
    label,
}) => {

  const [isVisible, setIsVisible] = useState(false);
  const internationalise = useSelector((state) => state?.internationalise?.currentHashMapData);
  const productType = useSelector((state) => state?.lookup?.lookupData)?.find((item) => item?.name == PRODUCT_TYPE)?.codes?.filter((item) => item?.status == ACTIVE_STATUS)?.sort((a, b) => a?.sequence - b?.sequence);
  const dispatch = useDispatch();
  const productData = useSelector(state => state?.product?.activeProducts);
  useEffect(() => {
      return () => {
          dispatch(emptyAllProducts());
      };
  }, [dispatch]);
  const handleChangeProductType = async () => {
    if (!searchState?.productType) {
      console.error("Product type is undefined!");
      return;
    }
    try{
     dispatch(requestShowLoader())
          const queryparams = {
            params: {
              type : searchState?.productType,
              status : "PRODUCT_STATUS_ACTIVE"
            }
          }
        dispatch(requestGetAllActiveProducts(queryparams));
  }
  catch(error){
  }
  finally{
    dispatch(requestHideLoader())
  }
  };

  useEffect(() => {
    if (searchState.productType) {
      handleChangeProductType();
    }
  }, [searchState.productType]);

  return (
    <>
                <SelectBoxWithLabel
                label={
                    label ||
                    handleValidateCodevalue(
                        internationalise,
                        "SO_SEARCH_PROD_NAME"
                    )
                }
                name="productName"
                value={value}
                optionMenuItem={productData}
                isStatic={false}
                ownerdropdown
                onMouseDown={(event) => {
                    event.preventDefault();
                    setIsVisible(true);
                }}
                SelectProps={{
                    open: false,
                }}
            />
  <LeadDialog
          open = {isVisible}
          handleClose = {()=>setIsVisible(false)}
          handleSave={()=>setIsVisible(false)}
          title= {handleValidateCodevalue(internationalise,"COMMON_CHOOSE_PROD_TYPE_AND_NAME")}
          sizeize="sm"
          btnlabel={handleValidateCodevalue(internationalise,"COMMON_SEARCH")}
          alternateBtnLabel={handleValidateCodevalue(internationalise,"COMMON_CANCEL")}>
                                    
        <Box sx={{ display: "flex", justifyContent:'space-evenly',alignItems:'center', }}>
          <TextFiledWithLabel
            select
            name="productType"
            handleOnChange={(e) => {
              handleChangeSearchField(e);
            }}
            id="productType"
            value={searchState?.productType}
            label={handleValidateCodevalue(internationalise, "COMMON_PRODUCT_TYPE")}
          >
            {productType?.map((option) => (
              <MenuItem key={option?.productId} value={option?.name}>
                {handleValidateCodevalue(internationalise, option?.name)}
              </MenuItem>
            ))}
          </TextFiledWithLabel>
          <TextFiledWithLabel
            select
            name="productId"
            handleOnChange={handleChangeSearchField}
            id="productId"
            value={searchState?.productId || ""}
            label={handleValidateCodevalue(internationalise, "COMMON_PRODUCT_NAME")}
          >
            {productData?.map((option) => {
              return (
                <MenuItem key={option?.name} value={option?.id}>
                  {option?.name}
                </MenuItem>
              );
            })}
          </TextFiledWithLabel>
        </Box>
        </LeadDialog>
        </>
  );
};
